let shopDomain = "tuxmat.com";

(function () {
	// Get references to DOM elements
	var toggleButton = document.getElementById("newToggleButtonforVehicle");

	var element = document.getElementById("vehicle-select-banner");
	var duration = 500; // duration in milliseconds
	var isSlidedUp = true;
	var targetHeight = null;

	// Toggle slideUp/slideDown
	function toggleSlide() {
		if (isSlidedUp) {
			slideDown(element);
		} else {
			slideUp(element);
		}
	}

	// Slide up
	function slideUp(a) {
		a.style.height = "0px";
		isSlidedUp = true;

		// Re-enable button after animation completes
		setTimeout(function () {
			toggleButton.disabled = false;
		}, duration);
	}

	// Slide down
	function slideDown(a) {
		targetHeight = a.scrollHeight;
		a.style.height = targetHeight + "px";
		isSlidedUp = false;

		// Re-enable button after animation completes
		setTimeout(function () {
			toggleButton.disabled = false;
		}, duration);
	}

	// Button click handler
	function handleButtonClick() {
		toggleButton.disabled = true; // Disable button during animation
		toggleSlide();
	}

	// Assign the click event handler to the button
	if (toggleButton) {
		toggleButton.onclick = function () {
			handleButtonClick();
		};
	}
})();

/** From theme.liquid */

let element = document.getElementById("box");
let elementHeight = null;
if (element) {
	elementHeight = element.clientHeight;
}

// flag to check if animation has been triggered
let animationTriggered = false;

// listen for scroll event and call animate function
/*document.addEventListener('scroll', function () {
  if (!animationTriggered && inView()) {
    animate();
    animationTriggered = true; // Set the flag to true once animation is triggered
  }
});*/

// check if element is in view
function inView() {
	// get window height
	var windowHeight = window.innerHeight;
	// get number of pixels that the document is scrolled
	var scrollY = window.scrollY || window.pageYOffset;

	// get current scroll position (distance from the top of the page to the bottom of the current viewport)
	var scrollPosition = scrollY + windowHeight;
	// get element position (distance from the top of the page to the bottom of the element)
	var elementPosition = element.getBoundingClientRect().top + scrollY + elementHeight;

	// is scroll position greater than element position? (is element in view?)
	if (scrollPosition > elementPosition) {
		return true;
	}

	return false;
}

function animate() {
	// is element in view?
	if (inView()) {
		// Get the element with the class name 'twentytwenty-handle'
		var handleElement = document.getElementsByClassName("twentytwenty-handle")[0];

		// Get the element with the class name 'twentytwenty-before'
		var handleElementImage = document.getElementsByClassName("twentytwenty-before")[0];

		// Get the element with the class name 'min-avg-max-slider-block'
		var sliderBlock = document.getElementsByClassName("min-avg-max-slider-block")[0];

		// Calculate the width and positions
		var sliderBlockWidth = sliderBlock.offsetWidth;
		var startLeft = sliderBlockWidth; // Start left position at the end of sliderBlock
		var targetLeft = sliderBlockWidth / 3; // Target left position in the middle of sliderBlock

		// Target values
		var targetClip = `rect(0px, ${
			handleElement.style.left || getComputedStyle(handleElement).left
		}, ${sliderBlock.offsetHeight}px, 0px)`; // Updated target clip

		// Get current values
		var currentLeft = parseFloat(handleElement.style.left || getComputedStyle(handleElement).left);
		var currentClip = handleElementImage.style.clip;

		// Define animation duration and start time
		var duration = 1000; // Animation duration in milliseconds
		var startTime = null;

		// Define animation function
		function animateStep(timestamp) {
			if (!startTime) startTime = timestamp;
			// Calculate progress
			var progress = (timestamp - startTime) / duration;
			// Apply custom cubic bezier easing to progress
			var easedProgress = customEasing(progress > 1 ? 1 : progress);
			// Apply lerp to left property
			handleElement.style.left = startLeft + (targetLeft - startLeft) * easedProgress + "px";

			// Adjust the left position based on clip width to keep it aligned with the handle
			handleElementImage.style.left =
				targetLeft - parseFloat(handleElementImage.style.clip.split(",")[1]) + "px";

			// Update clip property with interpolation
			var newClipValue = `rect(0px, ${
				handleElement.style.left || getComputedStyle(handleElement).left
			}, ${sliderBlock.offsetHeight}px, 0px)`;
			handleElementImage.style.clip = newClipValue;
			handleElementImage.style.left = "0";

			console.log("Current clip:", handleElementImage.style.clip);
			console.log("Current handle:", handleElement.style.left);

			// Check if animation duration has elapsed
			if (progress < 1) {
				// Continue animation
				requestAnimationFrame(animateStep);
			} else {
				// Animation complete
				console.log("Animation complete");
			}
		}

		// Start animation
		requestAnimationFrame(animateStep);
	}
}

// Custom cubic bezier easing function
function customEasing(x) {
	// Adjust control points for the desired easing effect
	return 1 - Math.pow(1 - x, 3); // Cubic bezier with control points (0.1, 0.9), (0.2, 0.8)
}

function getCssProperty(className, property) {
	var elems = document.getElementsByClassName(className);
	if (elems.length > 0) {
		var elem = elems[0]; // Assuming you want the first element with the specified class
		return window.getComputedStyle(elem, null).getPropertyValue(property);
	} else {
		return null; // Or any default value you prefer if the element is not found
	}
}

function toggleAccordion(el) {
	let $content = $(el).find(".more-content");
	let $toggleIcon = $(el).find(".toggle-icon");

	$(".toggle-icon.open").not($toggleIcon).removeClass("hidden");
	$(".toggle-icon.close").not($toggleIcon).addClass("hidden");

	// Check if the click target is not within the .more-content
	if (!$(event.target).closest(".more-content").length) {
		if ($content.is(":visible")) {
			$content.slideUp();
		} else {
			$(".more-content").slideUp();
			$content.slideDown();
		}

		$toggleIcon.toggleClass("hidden");
	}
}

function iosPolyfill(e) {
	var val =
			(e.pageX - diagramSlider.getBoundingClientRect().left) /
			(diagramSlider.getBoundingClientRect().right - diagramSlider.getBoundingClientRect().left),
		max = diagramSlider.getAttribute("max"),
		segment = 1 / (max - 1),
		segmentArr = [];

	max++;

	for (var i = 0; i < max; i++) {
		segmentArr.push(segment * i);
	}

	var segCopy = segmentArr.slice(),
		ind = segmentArr.sort((a, b) => Math.abs(val - a) - Math.abs(val - b))[0];

	diagramSlider.value = segCopy.indexOf(ind) + 1;
}

function showVideo(videoId, button) {
	var videoPlayer = document.getElementById("videoPlayer");
	videoPlayer.innerHTML =
		'<iframe width="560" height="315" src="' +
		videoId +
		'" title="YouTube video player" frameborder="0" allowfullscreen></iframe>';

	var buttons = document.querySelectorAll(".selected-btn-sub-page");
	buttons.forEach((btn) => {
		btn.classList.remove("selected-btn-sub-page");
	});

	button.classList.add("selected-btn-sub-page");
}

function checkOptionsMobile() {
	let make = document.getElementById("select-make-mobile").value;
	let model = document.getElementById("select-model-mobile").value;
	let year = document.getElementById("select-year-mobile").value;
	let bodyStyle = document.getElementById("select-body-style-mobile").value;
	let bodyStyleContainer = document.getElementById("body-style-container-mobile");
	let findButton = document.querySelector("#button-container-mobile button");
	let buttonContainer = document.getElementById("button-container-mobile");

	// Check if make, model, and year are selected
	if (make !== "" && model !== "" && year !== "") {
		// Check if body style has options
		if (bodyStyleContainer.querySelector("select").options.length > 1) {
			bodyStyleContainer.classList.remove("hidden"); // Show body style container

			if (bodyStyle !== "") {
				if (findButton) {
					// Check if body style is selected
					findButton.disabled = false; // Enable the button
				}
				buttonContainer.classList.remove("hidden"); // Show the button container
			} else {
				findButton.disabled = true; // Disable the button
				buttonContainer.classList.add("hidden"); // Hide the button container
			}
		} else {
			bodyStyleContainer.classList.add("hidden"); // Hide body style container
			if (findButton) {
				findButton.disabled = false; // Enable the button since body style isn't relevant
			}
			if (buttonContainer) {
				buttonContainer.classList.remove("hidden"); // Show the button container
			}
		}
	} else {
		// Hide body style container
		bodyStyleContainer.classList.add("hidden");
		// Disable the button
		if (findButton) {
			findButton.disabled = true;
		}
		// Hide the button container
		if (buttonContainer) {
			buttonContainer.classList.add("hidden");
		}
	}
}

function toggleDropdown(dropdownId) {
	var dropdownContent = document.getElementById(dropdownId);
	if (dropdownContent.classList.contains("show")) {
		dropdownContent.classList.remove("show");
	} else {
		dropdownContent.classList.add("show");
	}
}

function checkOptions() {
	let make = document.getElementById("select-make").value;
	let model = document.getElementById("select-model").value;
	let year = document.getElementById("select-year").value;
	let bodyStyle = document.getElementById("select-body-style").value;
	let bodyStyleContainer = document.getElementById("body-style-container");
	let findButton = document.getElementById("find-button");
	let buttonContainer = document.getElementById("button-container");

	// Check if make, model, and year are selected
	if (make !== "" && model !== "" && year !== "") {
		// Check if body style has options
		if (bodyStyleContainer.querySelector("select").options.length > 1) {
			bodyStyleContainer.classList.remove("hidden"); // Show body style container
			if (bodyStyle !== "") {
				// Check if body style is selected
				if (findButton) {
					findButton.disabled = false; // Enable the button
				}
				if (buttonContainer) {
					buttonContainer.classList.remove("hidden"); // Show the button container
				}
			} else {
				if (findButton) {
					findButton.disabled = true; // Disable the button
				}
				if (buttonContainer) {
					buttonContainer.classList.add("hidden"); // Hide the button container
				}
			}
		} else {
			bodyStyleContainer.classList.add("hidden"); // Hide body style container
			if (findButton) {
				findButton.disabled = false; // Enable the button since body style isn't relevant
			}
			if (buttonContainer) {
				buttonContainer.classList.remove("hidden"); // Show the button container
			}
		}
	} else {
		// Hide body style container
		bodyStyleContainer.classList.add("hidden");
		// Disable the button
		findButton.disabled = true;
		// Hide the button container
		if (buttonContainer) {
			buttonContainer.classList.add("hidden");
		}
	}
}

// commenting these out since we don't have #locationHeader anymore

// function cancelSiteMove(btn) {
// 	sessionStorage.setItem("visitorContinueOn", "yes");
// 	$("#locationHeader").slideUp();
// }

// window.onload = function () {
// 	if (shopDomain !== "tuxmat.com") return false;
// 	//checking location and showing location bar
// 	let continueOnThisSite = sessionStorage.getItem("visitorContinueOn") === "yes";
// 	let visitorCurrentLocation = sessionStorage.getItem("visitorCurrentLocation");
// 	if (visitorCurrentLocation == null) {
// 		console.log("Location lookup required...");
// 		//looking up visitor location
// 		geoip2.country(
// 			function (geoipResponse) {
// 				let location = geoipResponse.country.iso_code;
// 				//saving location into session
// 				sessionStorage.setItem("visitorCurrentLocation", location);
// 				//showing Location Bar, if location is CA
// 				if (location === "CA" && !continueOnThisSite) {
// 					$("#locationHeader").slideDown();
// 				} else {
// 					$("#locationHeader").slideUp();
// 				}
// 			},
// 			function (error) {
// 				console.log(error);
// 				console.log("GEO IP Service failed.");
// 			}
// 		);
// 	} else {
// 		if (visitorCurrentLocation === "CA") {
// 			//visitor location is available
// 			if (continueOnThisSite) {
// 				$("#locationHeader").slideUp();
// 			} else {
// 				$("#locationHeader").slideDown();
// 			}
// 		}
// 	}
// };

if (window.isFeaturedAudiPage) {
	$("#beforeafter").twentytwenty();

	var sync1 = $(".slider");
	var sync2 = $(".navigation-thumbs");

	var thumbnailItemClass = ".owl-item";

	var slides = sync1.owlCarousel({
		startPosition: 1,
		items: 1,
		loop: true,
		margin: 5,
		autoplay: true,
		autoplayTimeout: 6000,
		autoplayHoverPause: true,
		nav: false,
		dots: false
	});

	var thumbs = sync2
		.owlCarousel({
			startPosition: 1,
			items: 4,
			loop: false,
			margin: 5,
			autoplay: false,
			nav: false,
			dots: false,
			onInitialized: function (e) {
				var thumbnailCurrentItem = $(e.target).find(thumbnailItemClass).eq(this._current);
				thumbnailCurrentItem.addClass("synced");
			}
		})
		.on("click", thumbnailItemClass, function (e) {
			e.preventDefault();
			var duration = 300;
			var itemIndex = $(e.target).parents(thumbnailItemClass).index();
			sync1.trigger("to.owl.carousel", [itemIndex, duration, true]);
		})
		.on("changed.owl.carousel", function (el) {
			var number = el.item.index;
			$owl_slider = sync1.data("owl.carousel");
			$owl_slider.to(number, 100, true);
		});

	document.getElementById("playButton").addEventListener("click", function () {
		var video = document.getElementById("heroVideo");
		var logo = document.getElementById("logoImage");
		if (video.paused) {
			video.play();
			this.style.display = "none"; // Hide play button when video is playing
			logo.style.display = "none"; // Hide logo when video is playing
		} else {
			video.pause();
			this.style.display = "flex"; // Show play button when video is paused
			logo.style.display = "block"; // Show logo when video is paused
		}
	});
	console.log($(".imageSliderWrapper").length);
	if ($(".imageSliderWrapper").length > 0) {
		$(".imageSliderWrapper").twentytwenty();
	}
	// Get the modal
	var modal = document.getElementById("myModal");

	// Get the image and insert it inside the modal - use its "alt" text as a caption
	var images = document.querySelectorAll(".modal-image");
	var modalImg = document.getElementById("img01");
	var captionText = document.getElementById("caption");

	images.forEach(function (image, index) {
		image.onclick = function () {
			modal.style.display = "block";
			modalImg.src = this.src;
			captionText.innerHTML = this.alt;
		};
	});

	// Get the <span> element that closes the modal
	var span = document.getElementsByClassName("close")[0];

	// When the user clicks on <span> (x), close the modal
	span.onclick = function () {
		modal.style.display = "none";
	};
}
